const ADMIN_ROLES = new Set(["administrator", "admin", "superadmin"]);

export const getUserRoles = (user = {}) => [
  ...(Array.isArray(user.roles) ? user.roles : []),
  ...(user.role ? [user.role] : []),
].map((role) => String(role?.name ?? role).trim().toLowerCase()).filter(Boolean);

export const canDeleteCustomerFile = (file, user) => {
  const isAdmin = getUserRoles(user).some((role) => ADMIN_ROLES.has(role));
  if (isAdmin) return true;
  if (file?.uploadedByUserId == null) return false;
  return Number(file.uploadedByUserId) === Number(user?.id);
};
